import { useState } from 'react'
import { ActionTrigger, type ActionAs, type ActionItem } from '@/components/ActionBar'
import { nudgePatch } from '@/lib/follow'
import { useAccess } from '@/state/access'
import { mutate } from '@/runtime'

/**
 * "Nudge Alfie": a member's button on an open task; the owner's devices do not
 * have it. It writes the `nudge` label (an ordinary patch); the server decides
 * whether it becomes a push (once per task per ten minutes), so the button
 * only says it was sent.
 */
export const NudgeButton = ({ id, as }: { id: string; as?: ActionAs }) => {
  const isMember = useAccess((s) => s.member)
  const [sent, setSent] = useState(false)
  if (!isMember) return null
  return (
    <ActionTrigger
      as={as}
      label={sent ? 'Nudged' : 'Nudge Alfie'}
      disabled={sent}
      onClick={() => {
        setSent(true)
        void mutate.patch(id, { labels: nudgePatch() })
      }}
      testid="task-nudge"
    />
  )
}

/** The same button as an ActionBar item (a member's; hidden on the owner's devices). */
export const useNudgeItem = (id: string): ActionItem => {
  const isMember = useAccess((s) => s.member)
  return {
    id: 'nudge-alfie',
    label: 'Nudge Alfie',
    hidden: !isMember,
    render: ({ as }) => <NudgeButton id={id} as={as} />,
  }
}
